import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

// Reading User Answers
export const getReadingAnswers = () => apiClient.get(ENDPOINTS.ANSWERS.READING);
export const getReadingAnswerById = (id) => apiClient.get(ENDPOINTS.ANSWERS.READING_BY_ID(id));
export const deleteReadingAnswer = (id) => apiClient.delete(ENDPOINTS.ANSWERS.READING_BY_ID(id));

// Listening User Answers
export const getListeningAnswers = () => apiClient.get(ENDPOINTS.ANSWERS.LISTENING);
export const getListeningAnswerById = (id) => apiClient.get(ENDPOINTS.ANSWERS.LISTENING_BY_ID(id));
export const deleteListeningAnswer = (id) => apiClient.delete(ENDPOINTS.ANSWERS.LISTENING_BY_ID(id));

// Writing User Answers
export const getWritingAnswers = () => apiClient.get(ENDPOINTS.ANSWERS.WRITING);
export const getWritingAnswerById = (id) => apiClient.get(ENDPOINTS.ANSWERS.WRITING_BY_ID(id));
export const updateWritingAnswer = (id, data) => apiClient.put(ENDPOINTS.ANSWERS.WRITING_BY_ID(id), data);
export const deleteWritingAnswer = (id) => apiClient.delete(ENDPOINTS.ANSWERS.WRITING_BY_ID(id));

// Partner Admin Scoped Answers
export const getPartnerAdminReadingAnswers = (params) =>
  apiClient.get(ENDPOINTS.PARTNER_ADMIN.READING_ANSWERS, { params });
export const getPartnerAdminListeningAnswers = (params) =>
  apiClient.get(ENDPOINTS.PARTNER_ADMIN.LISTENING_ANSWERS, { params });
export const getPartnerAdminWritingAnswers = (params) =>
  apiClient.get(ENDPOINTS.PARTNER_ADMIN.WRITING_ANSWERS, { params });
export const updatePartnerAdminWritingAnswer = (id, data) =>
  apiClient.put(ENDPOINTS.PARTNER_ADMIN.WRITING_ANSWER(id), data);
